import Dashboard from '../views/Dashboard';
import NotFound from '../components/NotFound';
import Login from '../views/login';
import Events from '../views/Events/Events';

import PublicActivityPage from '../views/Events/pages/PublicActivityPage';

export const routes = [
  {
    path: '/',
    element: Dashboard,
    name: 'Dashboard'
  },
  {
    path: '/login',
    element: Login,
    name: 'Login'
  },
  {
    path: '/event',
    element: Events,
    name: 'Events'
  },
  {
    path: '/event/:id',
    element: Events,
    name: 'Event Detail'
  },
  {
    path: '/public/activity/:id',
    element: PublicActivityPage,
    name: 'Public Activity'
  },
  {
    path: '*',
    element: NotFound,
    name: 'Not Found'
  }
];
